import { render, staticRenderFns } from "./CartProductItem.vue?vue&type=template&id=38a3dc54&scoped=true"
import script from "./CartProductItem.vue?vue&type=script&lang=js"
export * from "./CartProductItem.vue?vue&type=script&lang=js"
import style0 from "./CartProductItem.vue?vue&type=style&index=0&id=38a3dc54&prod&lang=scss"
import style1 from "./CartProductItem.vue?vue&type=style&index=1&id=38a3dc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3dc54",
  null
  
)

export default component.exports